import { Authenticated } from "../../authenticated";
import { Dashboard } from "../../dashboard";
//Register all effects here
export const effectsConfig = [
    ...Authenticated.Effects,
    ...Dashboard.Effects,
];
